import React from 'react';
import { usePreviewContext } from '../providers/PreviewProvider';

export default function SectionReorderPanel() {
  const {
    resumeData,
    editMode,
    theme,
    handleReorderSections,
  } = usePreviewContext();

  if (!editMode || !resumeData) return null;

  // Build current section order
  const ALL_SECTIONS = [
    { key: 'summary', label: 'Summary' },
    { key: 'experience', label: 'Experience' },
    { key: 'internships', label: 'Internships' },
    { key: 'skills', label: 'Skills' },
    { key: 'education', label: 'Education' },
    { key: 'projects', label: 'Projects' },
    { key: 'certifications', label: 'Certifications' },
    { key: 'achievements', label: 'Achievements' },
    { key: 'languages', label: 'Languages' },
    { key: 'extracurricular', label: 'Extracurricular' },
  ];

  const existing = ALL_SECTIONS.filter(s => {
    const v = resumeData[s.key];
    return v && (typeof v === 'string' ? v.trim().length > 0 : v.length > 0);
  });

  const savedOrder = resumeData.section_order || [];
  const ordered = [
    ...savedOrder.map(k => existing.find(s => s.key === k)).filter(Boolean),
    ...existing.filter(s => !savedOrder.includes(s.key)),
  ];

  if (ordered.length < 2) return null;

  const moveSection = (idx, dir) => {
    const newOrder = [...ordered.map(s => s.key)];
    const swapIdx = idx + dir;
    if (swapIdx < 0 || swapIdx >= newOrder.length) return;
    [newOrder[idx], newOrder[swapIdx]] = [newOrder[swapIdx], newOrder[idx]];
    handleReorderSections(newOrder);
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 12,
        left: 12,
        zIndex: 25,
        background: theme === 'dark' ? 'rgba(24,24,27,0.95)' : 'rgba(255,255,255,0.95)',
        border: '1px solid var(--border-default)',
        borderRadius: 10,
        padding: '10px 12px',
        backdropFilter: 'blur(8px)',
        minWidth: 160,
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      }}
    >
      <p style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--brand)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>
        ↕ Section Order
      </p>
      {ordered.map((section, idx) => (
        <div key={section.key} style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 4 }}>
          <span style={{ flex: 1, fontSize: 10.5, color: 'var(--text-primary)', fontWeight: 500 }}>{section.label}</span>
          <button
            onClick={() => moveSection(idx, -1)}
            disabled={idx === 0}
            style={{
              fontSize: 10,
              lineHeight: 1,
              padding: '2px 5px',
              border: 'none',
              borderRadius: 4,
              cursor: idx === 0 ? 'not-allowed' : 'pointer',
              background: idx === 0 ? 'var(--sb-border)' : 'var(--brand-light)',
              color: idx === 0 ? 'var(--text-muted)' : 'var(--brand)',
            }}
            title="Move up"
          >
            ↑
          </button>
          <button
            onClick={() => moveSection(idx, 1)}
            disabled={idx === ordered.length - 1}
            style={{
              fontSize: 10,
              lineHeight: 1,
              padding: '2px 5px',
              border: 'none',
              borderRadius: 4,
              cursor: idx === ordered.length - 1 ? 'not-allowed' : 'pointer',
              background: idx === ordered.length - 1 ? 'var(--sb-border)' : 'var(--brand-light)',
              color: idx === ordered.length - 1 ? 'var(--text-muted)' : 'var(--brand)',
            }}
            title="Move down"
          >
            ↓
          </button>
        </div>
      ))}
    </div>
  );
}
